'use strict';

const { h } = require('preact');

const DiscountBadge = ({
  option: { pricing: { formattedDiscount }, isUrgencyPricing } = {},
  showBadgingBGColor,
  hasNoFeesValueProp,
}) => {
  if (!formattedDiscount) {
    return null;
  }

  let discountMessageClasses = 'discount-message';
  if (hasNoFeesValueProp) {
    discountMessageClasses = 'value-prop-message';
  } else if (showBadgingBGColor) {
    discountMessageClasses += ' badge-bg-color';

    if (isUrgencyPricing) {
      discountMessageClasses += ' urgency-pricing';
    } else {
      discountMessageClasses += ' c-txt-prim-dk';
    }
  } else {
    if (isUrgencyPricing) {
      discountMessageClasses += ' urgency-pricing c-txt-err c-bdr-err';
    } else {
      discountMessageClasses += ' c-txt-prim-dk';
    }
  }

  return h(
    'div',
    {
      class: 'discount-message-wrapper',
    },
    h(
      'div',
      {
        class: discountMessageClasses,
      },
      formattedDiscount
    )
  );
};

module.exports = DiscountBadge;
